var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"w-100 d-flex flex-column justify-content-center align-items-center",attrs:{"data-cy":"legacy"}},_vm._l((_vm.links),function(link){return _c('div',{key:link.name,staticClass:"h4 text-center"},[_c('a',{staticClass:"text-white",attrs:{"href":link.href}},[_vm._v("Click here to access "+_vm._s(link.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }